import React from 'react';

import { DataGrid } from '@mui/x-data-grid';

import GridPagination from '~/components/Common/Elements/GridPagination';

import { columns } from './columns';

interface Props {
  page: number;
  onPageChange: (page: number) => void;
  sizePerPage: number;
  purchases: Array<App.Order>;
  total: number;
}

export default function MerchandiseOrdersPage({ page, onPageChange, sizePerPage, purchases, total }: Props) {
  return (
    <DataGrid
      rows={purchases}
      rowCount={total}
      columns={columns}
      pagination
      paginationMode="server"
      paginationModel={{
        page: page - 1,
        pageSize: sizePerPage,
      }}
      pageSizeOptions={[sizePerPage]}
      classes={{
        root: 'T-merchandise-orders-container',
        virtualScrollerContent: 'T-merchandise-orders-table',
      }}
      slots={{ pagination: GridPagination }}
      onPaginationModelChange={({ page }) => onPageChange(page + 1)}
      getRowHeight={() => 'auto'}
      disableColumnFilter
      disableColumnMenu
      disableRowSelectionOnClick
      autoHeight
    />
  );
}
